import ALL_FILTERS from 'components/molecules/TagFilter/factories';
import { RootStateType as TransientPoolStateRootStateType } from 'store/transientPoolState';
import { PoolEnumType } from 'types/services/magnolia/enums/PoolEnum';
import { RootStateType } from '.';
import { PoolType } from '.';
import { getFilters } from '../transientPoolState';

export function getPoolExists(state: RootStateType, selectedPool: string): boolean {
	return !!~Object.keys(state.pools).indexOf(selectedPool);
}

export function getPool<T extends PoolType = any>(state: RootStateType, selectedPool: PoolEnumType): T {
	return (state.pools[selectedPool] as any) as T;
}

export function getItemsFromPool<T>(
	state: RootStateType & TransientPoolStateRootStateType,
	selectedPool: PoolEnumType
): { items: T[]; total: number } {
	let items = [];
	const pool = getPool(state, selectedPool);
	const filters = getFilters(state, selectedPool);
	const filterPipeline = Object.keys(filters)
		.map((filterId: string) => {
			// find out if an active filter exists for the currently mapped filter
			if (ALL_FILTERS[filterId] && filters[filterId] && filters[filterId] !== 'NONE') {
				return ALL_FILTERS[filterId].filter(filters[filterId]);
			}

			return undefined;
		})
		.filter(Boolean);

	if (pool) {
		items = pool.items || [];
	}

	return {
		items: filterPipeline.reduce((prev: any[], filterFn: any) => {
			if (filterFn) {
				return prev.filter(filterFn);
			}

			return prev;
		}, items),
		total: pool.items ? pool.items.length : 0,
	};
}

export function getPoolErrors(state: RootStateType, selectedPool: PoolEnumType): Error[] {
	const pool = getPool(state, selectedPool);

	if (pool) {
		return pool.errors || [];
	}

	return [];
}

export function getIsPoolReady(state: RootStateType, selectedPool: PoolEnumType): boolean {
	const pool = getPool(state, selectedPool);

	return pool && pool.ready;
}
